(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/image-v2/assets/javascripts/helpers/hbs-helpers.js') >= 0) return;  svs.modules.push('/components/content/image-v2/assets/javascripts/helpers/hbs-helpers.js');

'use strict';

var _require;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var loggerId = 'components:content:image-v2';
var cmsImagePrefix = '/cms/images';
var _svs = svs,
  isServer = _svs.isServer;
var _svs$utils = svs.utils,
  svsuid = _svs$utils.svsuid,
  getFileFormat = _svs$utils.getFileFormat;
var trinidad = isServer && ((_require = require('trinidad-core')) === null || _require === void 0 ? void 0 : _require.core);
var _ref = isServer ? require("".concat(__dirname, "/to-array-or-null.es6")) : svs.content.image_v2.helpers,
  toArrayOrNull = _ref.toArrayOrNull;
var logger = isServer ? trinidad.logger(loggerId) : new svs.core.log.Logger(loggerId);
var allowedMimeTypes = ['image/avif', 'image/jpeg', 'image/png', 'image/webp', 'image/svg+xml'];

var _getUrlWithCorrectHost = function getUrlWithCorrectHost(url, config) {
  if (!url) {
    return '';
  }
  return url.startsWith('http') ? url : "".concat(config.options.cdn2).concat(url);
};

var getUrlWithFilledPlaceholders = function getUrlWithFilledPlaceholders(url, width, extension) {
  var picassoData = "".concat(width, "/").concat(extension);
  url = url.replace(RegExp("^".concat(cmsImagePrefix)), "".concat(cmsImagePrefix, "/").concat(picassoData));
  return url;
};

var getWithFilledPlaceholders = function getWithFilledPlaceholders(url, width, extension) {
  url = url.replace('{width}', width);
  url = url.replace('{extension}', extension);
  return url;
};

var getUrl = function getUrl(image, extension, width) {
  var _image$url, _extension;
  var url;
  url = (image === null || image === void 0 || (_image$url = image.url) === null || _image$url === void 0 ? void 0 : _image$url.replace(/-({width}|%7Bwidth%7D)/g, '')) || '';
  url = getWithFilledPlaceholders(url, width, extension);
  if (image !== null && image !== void 0 && image.isPreview && !extension) {
    return url;
  }
  extension = ((_extension = extension) === null || _extension === void 0 ? void 0 : _extension.replace(/\./g, '')) || 'original';
  width = image !== null && image !== void 0 && image.originalImage ? 'original' : width;
  return getUrlWithFilledPlaceholders(url, width, extension);
};

var getSrcsetString = function getSrcsetString(image, extension, width, config) {
  var _image$availableForma;
  var output;

  output = getUrl(image, extension || ((_image$availableForma = image.availableFormats) === null || _image$availableForma === void 0 || (_image$availableForma = _image$availableForma[0]) === null || _image$availableForma === void 0 ? void 0 : _image$availableForma.extension) || 'webp', width);

  output = _getUrlWithCorrectHost(output, config);

  output = "".concat(output).concat(isNaN(width) ? ' ' : " ".concat(width, "w"));
  return output;
};

function registerHelpers(hbs, config) {
  var handlebarsHelpers = {
    getUrlWithCorrectHost: function getUrlWithCorrectHost(url, config) {
      return _getUrlWithCorrectHost(url, config);
    },
    contentImageHeight: function contentImageHeight(context) {
      var _ref2 = context || null,
        height = _ref2.height,
        width = _ref2.width;
      var fallbackHeight = 43.75;
      return width && height ? height / width * 100 : fallbackHeight;
    },
    getUniqueSelector: function getUniqueSelector() {
      return "image-".concat(svsuid());
    },
    getSrcset: function getSrcset(image, extension) {
      var _image$availableWidth;
      var srcsetArray = (image === null || image === void 0 || (_image$availableWidth = image.availableWidths) === null || _image$availableWidth === void 0 ? void 0 : _image$availableWidth.map(function (width) {
        return getSrcsetString(image, extension, width, config);
      })) || _getUrlWithCorrectHost(getUrl(image, extension), config);
      return new hbs.SafeString(srcsetArray.toString());
    },
    setVar: function setVar(name, value) {
      this[name] = value;
    },
    getSourceElementsData: function getSourceElementsData(image) {
      var _getFileFormat;
      if (!image) {
        logger.warn('No image data provided.');
        return;
      }
      var loadingLazy = image.loadingLazy,
        url = image.url,
        media = image.media,
        imageSizes = image.sizes;

      var originalFormat = {
        extension: 'original',
        mimeType: (_getFileFormat = getFileFormat(url)) === null || _getFileFormat === void 0 ? void 0 : _getFileFormat.mimeType
      };

      var formats = originalFormat.mimeType === 'image/svg+xml' ? [originalFormat] : [getFileFormat('webp'), originalFormat];
      var sourcesData = formats.map(function (_ref3) {
        var extension = _ref3.extension,
          mimeType = _ref3.mimeType;
        var getSrcset = handlebarsHelpers.getSrcset;
        var id = svsuid();
        var dataSrc = loadingLazy ? getSrcset(image, extension) : null;
        var srcSet = !loadingLazy ? getSrcset(image, extension) : null;
        var type = mimeType;
        var sizesFallback = '100vw';
        var sizes = imageSizes || sizesFallback;
        if (!allowedMimeTypes.includes(mimeType)) {
          logger.warn("The MIME type `".concat(mimeType, "` is not supported. ") + "Supported MIME types: `".concat(allowedMimeTypes.join('`, `'), "`. ") + "Image URL: `".concat(url, "`."));
        }
        return {
          id: id,
          dataSrc: dataSrc,
          media: media,
          sizes: sizes,
          srcSet: srcSet,
          type: type
        };
      });
      return sourcesData;
    },
    stringifyImagesObject: function stringifyImagesObject(input) {
      var imagesArray = toArrayOrNull(input);
      if (imagesArray) {
        var customImagesArray = imagesArray.map(function (item) {
          return item ? {
            aspectRatio: item.aspectRatio,
            dominantColor: item.dominantColor,
            media: item.media
          } : undefined;
        });
        return JSON.stringify(customImagesArray);
      }
      return null;
    },
    setStyleElement: function setStyleElement(selector, imagesObject) {
      if (svs.isBrowser) {
        var setStyleElement = svs.content.image_v2.helpers.multiImageStyleElement.setStyleElement;
        setStyleElement(selector, imagesObject);
      }
    },
    getNoscriptUrl: function getNoscriptUrl(image, images, noscriptUrl, isMultiImage) {
      var getWidestItem = function getWidestItem(items) {
        return (items === null || items === void 0 ? void 0 : items.reduce(function (prev, curr) {
          return (prev === null || prev === void 0 ? void 0 : prev.width) > (curr === null || curr === void 0 ? void 0 : curr.width) ? prev : curr;
        }, {
          width: 0
        })) || null;
      };
      var $noscriptUrl = isMultiImage ? noscriptUrl : image === null || image === void 0 ? void 0 : image.noscriptUrl;

      var getMultiImageFallback = function getMultiImageFallback() {
        return getWidestItem(images && Object.values(images));
      };
      var getFallbackUrl = function getFallbackUrl() {
        var _fallbackImage$availa, _fallbackImage$availa2;
        var fallbackImage = isMultiImage ? getMultiImageFallback() : image;
        var highestWidth = fallbackImage !== null && fallbackImage !== void 0 && (_fallbackImage$availa = fallbackImage.availableWidths) !== null && _fallbackImage$availa !== void 0 && _fallbackImage$availa.includes('original') || fallbackImage !== null && fallbackImage !== void 0 && fallbackImage.originalImage ? 'original' : Math.max.apply(Math, _toConsumableArray((fallbackImage === null || fallbackImage === void 0 ? void 0 : fallbackImage.availableWidths) || [0]));
        var extension = fallbackImage === null || fallbackImage === void 0 || (_fallbackImage$availa2 = fallbackImage.availableFormats) === null || _fallbackImage$availa2 === void 0 || (_fallbackImage$availa2 = _fallbackImage$availa2[0]) === null || _fallbackImage$availa2 === void 0 ? void 0 : _fallbackImage$availa2.extension;
        return getUrl(fallbackImage, extension, highestWidth);
      };
      var url = $noscriptUrl || getFallbackUrl();
      return _getUrlWithCorrectHost(url, config);
    }
  };

  for (var helperName in handlebarsHelpers) {
    if (helperName in handlebarsHelpers) {
      hbs.registerHelper(helperName, handlebarsHelpers[helperName]);
    }
  }
}
if (isServer) {
  var _require2 = require('trinidad-core'),
    core = _require2.core;
  registerHelpers(require('hbs'), core.config);
} else {
  var _svs$core;
  var config = {
    options: (_svs$core = svs.core) === null || _svs$core === void 0 || (_svs$core = _svs$core.config) === null || _svs$core === void 0 || (_svs$core = _svs$core.data) === null || _svs$core === void 0 ? void 0 : _svs$core.svsconfig
  };
  registerHelpers(Handlebars, config);
}

 })(window);